import { css } from '@emotion/react'
import { SpacingToken } from '@livechat/design-system-react-components'

import baseStyles from 'gatsby-theme-marketplace-base/src/layout/category-styles'
import mediaQueries from './media-queries'

export default {
  category: (theme) => css`
    ${baseStyles.category(theme)};
    position: relative;
    margin-top: 0;

    padding-left: 0px;
    padding-right: 0px;

    ${mediaQueries.smallScreen()} {
      padding-right: 0;
      padding-left: 0;
    }

    ${mediaQueries.mediumScreen()} {
      padding-right: 0;
    }

    .content {
      .sidebar {
        display: none;
      }

      .bottom-bar {
        display: none;
      }
    }
  `,
  featuredCategories: (isOddItemsCount) => css`
    margin-top: var(${SpacingToken.Spacing6});

    @media (min-width: ${mediaQueries.BASE_SMALL_SIZE -
      150}px) and (max-width: ${mediaQueries.BASE_LARGE_SIZE - 301}px) {
      > div:last-of-type > article:last-of-type {
        ${isOddItemsCount && `display: none;`}
      }
    }
  `,
}
